module.exports = __webpack_public_path__ + "static/media/eviivo.2c1d9596.png";